import { Component, Input, OnInit, ChangeDetectionStrategy, inject } from '@angular/core';
import { ToastrService } from 'ngx-toastr';

import { ToasterConfig } from 'src/app/_shared/toaster/toaster-config.model';
import { ToasterService } from 'src/app/_shared/toaster/toaster.service';

/**
 * Takes the place of angular2-toaster's <toaster-container>. ngx-toastr renders the toasts in its own
 * overlay, so this only applies the config.
 */
@Component({
  // Keeps the angular2-toaster selector used in app.component.html.
  // eslint-disable-next-line @angular-eslint/component-selector
  selector: 'toaster-container',
  template: '',
  changeDetection: ChangeDetectionStrategy.Eager,
  standalone: false
})
export class ToasterContainerComponent implements OnInit {
  private toasterService = inject(ToasterService);
  private toastrService = inject(ToastrService);

  @Input() toasterconfig = new ToasterConfig();

  ngOnInit(): void {
    this.toasterService.config = this.toasterconfig;
    // angular2-toaster's limit drops the oldest toast when a new one would exceed it.
    this.toastrService.toastrConfig.maxOpened = this.toasterconfig.limit || 0;
    this.toastrService.toastrConfig.autoDismiss = true;
  }
}
